var map = {
	"./Icon/index.js": "qxIs",
	"./Icon/map-circl-block.js": "rYTN",
	"./Icon/map-circl.js": "lDqU",
	"./Odnoklassniki.js": "noVB",
	"./RocketLaunch.js": "iqYg",
	"./advice.js": "0Ui7",
	"./arrow-long-2.js": "LKMQ",
	"./arrow-long-3.js": "LvHA",
	"./arrow-long-4.js": "YntZ",
	"./arrow-long.js": "cm6L",
	"./arrow_big.js": "aipK",
	"./attention.js": "nlTz",
	"./book-open.js": "6xjU",
	"./book-presentation.js": "MWOA",
	"./briefcase.js": "u+bm",
	"./calendar-2.js": "FEHr",
	"./calendar.js": "ag30",
	"./check-circle.js": "0ffg",
	"./check.js": "4Z76",
	"./circle-replacement.js": "H/Ne",
	"./circle-tank-storage.js": "lIzh",
	"./circle-windmill.js": "+UUT",
	"./close.js": "Nujm",
	"./closure.js": "Qp7/",
	"./cn/award.js": "w0VX",
	"./cn/award_mob.js": "6miw",
	"./cn/construction.js": "Z15v",
	"./cn/construction_mob.js": "6I/r",
	"./cn/garbage_car.js": "7ouK",
	"./cn/garbage_car_mob.js": "s9wM",
	"./cn/index.js": "P2ez",
	"./cn/pin-cnn.js": "TPk1",
	"./cn/pin-cnn_mob.js": "AhWC",
	"./cn/plan.js": "YPNA",
	"./cn/plan_mob.js": "Gvfc",
	"./cn/reclamation.js": "Q5LU",
	"./cn/reclamation_mob.js": "gilr",
	"./cn/working.js": "EOwu",
	"./cn/working_mob.js": "Lxya",
	"./co2.js": "GpB1",
	"./conformity.js": "uV1r",
	"./cooperation.js": "lM04",
	"./covid.js": "I0Xs",
	"./covid_plan.js": "wmYM",
	"./cu.js": "I1Oy",
	"./danger.js": "3DVR",
	"./danger_mini.js": "LmdQ",
	"./decline.js": "P6hF",
	"./delivery-ship.js": "1/Uo",
	"./delivery.js": "+lWl",
	"./development.js": "DAPh",
	"./dometory.js": "3cpL",
	"./download.js": "0+cP",
	"./efficiency-big.js": "a78t",
	"./efficiency.js": "T/TO",
	"./enrichment.js": "T+Br",
	"./esg-big.js": "EdNh",
	"./esg-numbers.js": "qDqt",
	"./esg-round.js": "klNc",
	"./esg.js": "sJ+u",
	"./excursion.js": "uBj+",
	"./external-hover.js": "sFEI",
	"./external.js": "WlZX",
	"./eye.js": "qRua",
	"./faq-answer.js": "YRlU",
	"./faq-attention.js": "GxQ4",
	"./faq-question.js": "qa2z",
	"./fax.js": "/niX",
	"./file-big/danger.js": "N9n7",
	"./file-big/doc.js": "Uikv",
	"./file-big/index.js": "DjyW",
	"./file-big/mic.js": "L+gz",
	"./file-big/mp3.js": "ET0R",
	"./file-big/pdf.js": "Iq+V",
	"./file-big/photo.js": "J7V4",
	"./file-big/presentation.js": "UgH2",
	"./file-big/press-release.js": "jY5J",
	"./file-big/rf.js": "FFI9",
	"./file-big/rub.js": "d9mt",
	"./file-big/upload.js": "+yAm",
	"./file-big/usd.js": "tsVL",
	"./file-big/video.js": "tq3a",
	"./file-small/danger.js": "xsJu",
	"./file-small/index.js": "qk01",
	"./file-small/pdf.js": "9TzZ",
	"./file-small/press-release.js": "GnO6",
	"./file-small/rar.js": "kmew",
	"./file-small/rub.js": "ZkXj",
	"./file-small/usd.js": "xl0H",
	"./file-small/zip.js": "rrix",
	"./file-text.js": "9bOY",
	"./file/book.js": "uCmT",
	"./file/default.js": "h36V",
	"./file/doc.js": "JBrR",
	"./file/docx.js": "E+Iz",
	"./file/empty.js": "vIt1",
	"./file/index.js": "huiA",
	"./file/jpg.js": "OiIb",
	"./file/mp3.js": "EKQ/",
	"./file/mp4.js": "CtCp",
	"./file/online.js": "rpQL",
	"./file/pdf.js": "etp7",
	"./file/png.js": "FGOy",
	"./file/ppt.js": "Ujt1",
	"./file/pptx.js": "AwRR",
	"./file/rar.js": "ARRv",
	"./file/rtf.js": "MERq",
	"./file/text-doc.js": "Gfu2",
	"./file/text-docx.js": "lOOB",
	"./file/text-jpg.js": "qEJP",
	"./file/text-mp3.js": "Ue5z",
	"./file/text-mp4.js": "6zI7",
	"./file/text-pdf.js": "K5uV",
	"./file/text-png.js": "bo4I",
	"./file/text-ppt.js": "U1Dm",
	"./file/text-rar.js": "MRUv",
	"./file/text-rtf.js": "ddO5",
	"./file/text-tif.js": "CD2H",
	"./file/text-txt.js": "Mfbi",
	"./file/text-xls.js": "i8Gp",
	"./file/text-xlsx.js": "l0U6",
	"./file/text-zip.js": "tLfk",
	"./file/tif.js": "oie8",
	"./file/txt.js": "zYZd",
	"./file/xbrl.js": "do+t",
	"./file/xls.js": "VV3I",
	"./file/xlsx.js": "ANhb",
	"./file/zip.js": "JhIZ",
	"./filtering.js": "xVi9",
	"./financial-growth.js": "3H3A",
	"./financial-results.js": "jGi9",
	"./flag.js": "OuRg",
	"./flagbanner.js": "Pa7T",
	"./folder.js": "NhAC",
	"./fon.js": "mE3o",
	"./gear-line.js": "pLbU",
	"./gear.js": "wHDK",
	"./geological-exploration.js": "B997",
	"./goal-big.js": "DEbO",
	"./gold.js": "Uosh",
	"./google.js": "jXo0",
	"./hands.js": "9Lyl",
	"./ical.js": "D3s2",
	"./icon-brand-care-text.js": "Wfro",
	"./icon-brand-care.js": "HRWq",
	"./icon-brand-efficiency-text.js": "AeHc",
	"./icon-brand-efficiency.js": "al/o",
	"./icon-brand-safety-text.js": "+bg3",
	"./icon-brand-safety.js": "/xAo",
	"./icon_element/Ag.js": "CkAG",
	"./icon_element/Au.js": "9i46",
	"./icon_element/Co.js": "FpBk",
	"./icon_element/Cu.js": "FOOF",
	"./icon_element/Ir.js": "mzFP",
	"./icon_element/Na2SO4.js": "ottH",
	"./icon_element/NaCl.js": "CBcu",
	"./icon_element/Ni.js": "ZLoC",
	"./icon_element/Pd.js": "hFR/",
	"./icon_element/Pt.js": "/v0y",
	"./icon_element/Rh.js": "EgAN",
	"./icon_element/Ru.js": "deJk",
	"./icon_element/S.js": "qKNk",
	"./icon_element/Se.js": "B3O/",
	"./icon_element/Variant9.js": "tmFM",
	"./icon_element/index.js": "M/v+",
	"./icon_element/nornik.js": "qUb4",
	"./icon_elementTe.js": "XTtc",
	"./icon_element_backbone_infrastructure.js": "WZzv",
	"./icon_element_culture.js": "eJuI",
	"./icon_element_demography.js": "0w2x",
	"./icon_element_digital_economy.js": "VBHI",
	"./icon_element_ecology.js": "nYK5",
	"./icon_element_education.js": "IKzj",
	"./icon_element_healthcare.js": "mjsM",
	"./icon_element_housing_and_urban_environment.js": "djxc",
	"./icon_element_labor_productivity.js": "R7nc",
	"./icon_element_science_and_universities.js": "D0eO",
	"./icon_element_small_and_medium_enterprises.js": "8xaQ",
	"./icon_element_tourism.js": "AaEr",
	"./icons/index.js": "RKkU",
	"./icons/map-map-block.js": "Wh8M",
	"./icons/map-map.js": "NU0t",
	"./img.js": "+X7I",
	"./index.js": "HfD5",
	"./industrial.js": "6vrd",
	"./leader.js": "rOxG",
	"./leader_big.js": "KRJA",
	"./leaf-air.js": "HFt8",
	"./loader.js": "uZGp",
	"./logistics-sales.js": "zEOa",
	"./logo-for-contactcard.js": "CQfs",
	"./logo_sulfur.js": "LREM",
	"./m1.js": "n8ru",
	"./m2.js": "MR4x",
	"./m3.js": "ANUA",
	"./m4.js": "XU8E",
	"./m5.js": "K2ie",
	"./magnifier.js": "NIuI",
	"./man.js": "TyHa",
	"./map-all.js": "Khzk",
	"./map_all-default.js": "PIoD",
	"./map_asset.js": "wBJM",
	"./map_asset_default.js": "BGQm",
	"./map_delivery/airplane.js": "bfHg",
	"./map_delivery/index.js": "QdiF",
	"./map_delivery/ship.js": "GKnL",
	"./map_delivery/truck.js": "GEGL",
	"./map_development.js": "4TYf",
	"./map_development_default.js": "DdU1",
	"./map_sales.js": "APLD",
	"./map_sales_default.js": "hfIa",
	"./map_ship.js": "X99G",
	"./map_ship_default.js": "3NX3",
	"./marketing.js": "BxFH",
	"./medical-case.js": "i3Wm",
	"./medical-ventilators.js": "J9tk",
	"./megaworker.js": "m2um",
	"./menu.js": "r5nO",
	"./message.js": "5+2v",
	"./metal-production.js": "Mpwd",
	"./mic.js": "brVM",
	"./microscope.js": "2ZmN",
	"./mine-digital.js": "yNXh",
	"./mine.js": "MoBh",
	"./mini_history.js": "7m/t",
	"./minilogo.js": "JTR3",
	"./mining-industry.js": "A5pE",
	"./mining-processing.js": "lvzi",
	"./mining.js": "mU6B",
	"./minning-2.js": "c6A/",
	"./mintransport.js": "/E2O",
	"./monitor-play.js": "9wfy",
	"./monitor.js": "R4UV",
	"./ni.js": "DKOa",
	"./niokr.js": "1256",
	"./ore.js": "eOjX",
	"./outlook.js": "hLtU",
	"./paperclip.js": "ykKk",
	"./pause_bold.js": "zxap",
	"./people-default.js": "MTP/",
	"./phone.js": "UWCZ",
	"./pin-nn.js": "aq8a",
	"./pin.js": "+p6o",
	"./piople_save.js": "B0md",
	"./play-block.js": "EczI",
	"./play.js": "tSUg",
	"./play_bold.js": "VxXj",
	"./plus.js": "5P8Y",
	"./point.js": "eHih",
	"./product-lme.js": "Aa8P",
	"./product-shfe.js": "d9sl",
	"./products-burger.js": "rczK",
	"./professionalism.js": "j3rO",
	"./profit.js": "SKrW",
	"./protect-mask.js": "AMIc",
	"./pulse.js": "a2A5",
	"./quote.js": "1yRI",
	"./reanimobiles.js": "+wBK",
	"./refining.js": "z2QS",
	"./refresh.js": "ZCvc",
	"./reliability.js": "NS8D",
	"./replacement.js": "JJur",
	"./reporting.js": "S6ws",
	"./reserves.js": "GQU3",
	"./reward.js": "Q/9s",
	"./rf-big-white.js": "61G1",
	"./rf-block.js": "zJB1",
	"./rf-small-blue.js": "Hwja",
	"./round-arrow-folder/arrow.js": "qpjj",
	"./round-arrow-folder/index.js": "vhy7",
	"./round-arrow-folder/line-l.js": "bXQH",
	"./round-arrow-folder/line-m.js": "XpjX",
	"./round-arrow.js": "qZP8",
	"./round_mail _hover.js": "iNqd",
	"./round_mail.js": "VHKE",
	"./round_pdf.js": "+FbL",
	"./rss.js": "zfHx",
	"./sap.js": "8vVk",
	"./search/blue.js": "YUQI",
	"./search/index.js": "8Cpi",
	"./search/white.js": "wbRL",
	"./server.js": "oAvF",
	"./share-2.js": "vXj0",
	"./share.js": "LeyM",
	"./ship.js": "xMPs",
	"./smartlab.js": "u+82",
	"./smelting.js": "psyJ",
	"./social-card.js": "hNLT",
	"./social-group.js": "g8tr",
	"./social/index.js": "rkax",
	"./social/share.js": "/LhN",
	"./sort-down.js": "xkCO",
	"./sort-up.js": "SZKg",
	"./sources.js": "QxZI",
	"./statistics.js": "qeT1",
	"./storage.js": "9iWk",
	"./sufficiency.js": "i+uK",
	"./tadviser.js": "T1pE",
	"./tags.js": "a4Gx",
	"./tank-storage.js": "yCdc",
	"./tech-leadership.js": "3ccp",
	"./techno-machine.js": "2IeK",
	"./telegram.js": "ycPR",
	"./tests.js": "fXvt",
	"./text/index.js": "RzVJ",
	"./text/rub.js": "+TVo",
	"./text/usd.js": "uFTB",
	"./time.js": "qso5",
	"./tooltip-hover.js": "PqIw",
	"./tooltip.js": "WlEO",
	"./tutor.js": "UclS",
	"./two-arrow.js": "/44A",
	"./upload.js": "oYCO",
	"./user.js": "0Pq4",
	"./video.js": "IjP4",
	"./vk.js": "zysx",
	"./wifi.js": "H6fy",
	"./win.js": "q0ki",
	"./windmill.js": "yuUo",
	"./worker.js": "JjSD",
	"./workers.js": "cXpb",
	"./youtube.js": "acla",
	"./сopy_link.js": "RQGr"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e6lb";